import * as React from "react";
import { useState } from "react";
import WelcomeScreen from "./WelcomeScreen";
import LoginScreen from "./LoginScreen";

interface AuthFlowProps {
  onLoginSuccess: (userId: string) => void;
}

const AuthFlow: React.FC<AuthFlowProps> = ({ onLoginSuccess }) => {
  const [showLogin, setShowLogin] = useState(false);

  if (!showLogin) {
    return <WelcomeScreen onContinue={() => setShowLogin(true)} />;
  }

  return <LoginScreen onLoginSuccess={onLoginSuccess} />;
};

export default AuthFlow;



